module.exports = __webpack_public_path__ + "static/media/32.0dbb7b6c.jpg";